import React, { Fragment } from 'react'
import { Typography, Button, Box} from '@mui/material'
import { usePutAway } from '../../Context/usePutAway'
import { putAwayActions } from '../../actions/putAwayActions'
import { FlipBackOptions } from '../../types/enums'

interface ExcessNotificationProps {}

export const ExcessNotification: React.FC<ExcessNotificationProps> = () => {
  const { dispatch } = usePutAway()
  const { setIsShowExcess, handleResetLocate, terminateLocateAsn, handleFlipGetHistory } =
    putAwayActions()

  return (
    <Fragment>
      <Box
        component='div'
        display='flex'
        flexDirection='column'
        flexWrap='nowrap'
        alignItems='center'
        padding='10px 20px 0 20px'
        border='1px solid red'
        color='red'
        width='83%'
        borderRadius='10px'
        marginTop='5%'
      >
        <Typography
          variant='h6'
          component='p'
          style={{ textAlign: 'center', textAlignLast: 'center' }}
        >
          Estás ingresando más unidades de las esperadas en la ASN. ¿Es
          correcto?
        </Typography>
        <Typography
                  variant='subtitle2'
                  component='p'
                  style={{ textAlign: 'center', textAlignLast: 'center', fontStyle: 'italic' }}
        >
          Por favor apartar estas cantidades en el lugar designado. Recordar que el sistema NO ingresará estas unidades adicionales
        </Typography>
        <Button
          type='submit'
          fullWidth
          variant='outlined'
          color='primary'
          style={{
            marginTop: '20px',
            width: '95%',
            minWidth: '95%'
          }}
          onClick={() => handleFlipGetHistory(FlipBackOptions.ProductProblems)}
        >
          Más Detalle
        </Button>
        <Button
          type='submit'
          fullWidth
          variant='outlined'
          color='primary'
          style={{
            marginTop: '20px',
            width: '95%',
            minWidth: '95%'
          }}
          onClick={() => {
            terminateLocateAsn()
            dispatch(setIsShowExcess(false))
          }}
        >
          Sí, es correcto
        </Button>

        <Button
          type='submit'
          fullWidth
          variant='outlined'
          color='primary'
          style={{
            marginTop: '20px',
            width: '95%',
            minWidth: '95%',
            marginBottom: '20px'
          }}
          onClick={() => {
            handleResetLocate()
            dispatch(setIsShowExcess(false))
          }}
        >
          Cancelar
        </Button>
      </Box>
    </Fragment>
  )
}
